import { render } from "./dentrion_place.vue?vue&type=template&id=6d1b6a3e&scoped=true"
import script from "./dentrion_place.vue?vue&type=script&lang=js"
export * from "./dentrion_place.vue?vue&type=script&lang=js"

import "./dentrion_place.vue?vue&type=style&index=0&id=6d1b6a3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d1b6a3e"]])

export default __exports__